var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5007 30.8236C6.98603 30.8236 0.0839844 23.9215 0.0839844 15.4069C0.0839844 6.89228 6.98603 -0.00976562 15.5007 -0.00976562C24.0153 -0.00976562 30.9173 6.89228 30.9173 15.4069C30.9173 23.9215 24.0153 30.8236 15.5007 30.8236ZM15.5007 13.227L11.1408 8.86561L8.95936 11.0471L13.3207 15.4069L8.95936 19.7667L11.1408 21.9482L15.5007 17.5868L19.8605 21.9482L22.0419 19.7667L17.6806 15.4069L22.0419 11.0471L19.8605 8.86561L15.5007 13.227Z",
    fill: "#B3B7BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3531ab773d90b06f6cd2d44f66ca35c8.svg";
export { ForwardRef as ReactComponent };